/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = {
  [_ in K]?: never;
};
export type Incremental<T> =
  T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  /** BigInt representation */
  BigInt: { input: any; output: any };
  /** Email address */
  EmailAddress: { input: any; output: any };
  /** Timestamp */
  EpochMillis: { input: any; output: any };
  /** Locale BCP 47 Standard Language Tag for Language Human Readable Languages */
  Locale: { input: any; output: any };
  /** Long */
  Long: { input: any; output: any };
  /** mdx scalar */
  MDX: { input: any; output: any };
  /** Timezone */
  Timezone: { input: any; output: any };
  /** url scalar */
  URL: { input: any; output: any };
};

/** EULA Acceptance Response */
export type AcceptEulaAgreementPayload = {
  __typename?: 'AcceptEulaAgreementPayload';
  /** Indicates if the EULA has been accepted. True if accepted, false if not. */
  accepted: Scalars['Boolean']['output'];
  /** Version of the EULA that was accepted */
  version: Scalars['Int']['output'];
};

/** List of available article categories for displaying a feed */
export enum ArticleCategory {
  /** Article is a link */
  Link = 'LINK',
  /** Article is a post */
  Post = 'POST',
}

/** Attachment details */
export type Attachment = {
  __typename?: 'Attachment';
  /** Filename of the attachment */
  fileName: Scalars['String']['output'];
  /** File type of the attachment */
  type: Scalars['String']['output'];
  /** URL location of the attachment */
  url: Scalars['String']['output'];
};

/** Cache Control Scope Options */
export enum CacheControlScope {
  /** If a cached response has a PRIVATE scope, its value is accessible by only a single user. To enforce this restriction, the cache needs to know how to identify that user. */
  Private = 'PRIVATE',
  /** By default, PUBLIC cached responses are accessible by all users. */
  Public = 'PUBLIC',
}

/** Response from registering for teams push notifications */
export type ChannelsTeamsPushRegistrationResponse = {
  __typename?: 'ChannelsTeamsPushRegistrationResponse';
  /** Error message if any occurred */
  body?: Maybe<Scalars['String']['output']>;
  /** Status code of request */
  status: TeamsRegistrationResponseStatus;
};

/** Comment on a post */
export type Comment = Node & {
  __typename?: 'Comment';
  /** Name of user who commented */
  author: Scalars['String']['output'];
  /**
   * Cognito identifier of user who is commented
   * @deprecated Legacy identification token- deprecated in favour of poppuloId. Deprecation date 2023-06-03T00:00:00Z
   */
  cognitoSubId?: Maybe<Scalars['String']['output']>;
  /** Denotes whether comment returned was by requesting user */
  commentByUser?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Unique identifier of comment
   * @deprecated id should be used instead. Deprecation date 2022-11-03T00:00:00Z
   */
  commentId: Scalars['String']['output'];
  /** Content of comment */
  content: Scalars['String']['output'];
  /** Unique identifier of comment */
  id: Scalars['ID']['output'];
  /** Poppulo identifier of user who commented */
  poppuloId?: Maybe<Scalars['String']['output']>;
  /** Post id associated with this comment */
  postId: Scalars['String']['output'];
  /** Comment publication status */
  status?: Maybe<Status>;
  /** Epoch time for when comment was published */
  timeOfPublish: Scalars['String']['output'];
};

/** CommentComponent Type */
export type CommentComponent = {
  __typename?: 'CommentComponent';
  /** Body of comment */
  body: Scalars['String']['output'];
};

/** Comments Type */
export type Comments = {
  __typename?: 'Comments';
  /** Count of comments related to feed query */
  commentCount: Scalars['Int']['output'];
  /** List of comments related to feed query */
  comments: Array<Comment>;
};

/** Components associated with a post */
export type Components = {
  __typename?: 'Components';
  /** List of attachments associated with a post */
  attachments?: Maybe<Array<Attachment>>;
  /** Comment parser component */
  comment?: Maybe<CommentComponent>;
  /**
   * Image to be displayed when viewing post
   * @deprecated 'images' should be read instead. Deprecation date 2022-11-03T00:00:00Z
   */
  image?: Maybe<Image>;
  /** Images to be displayed when viewing post */
  images: Array<Image>;
  /** Link that is associated with a post */
  link?: Maybe<Link>;
  /** Estimated Reading Time of a post */
  readingTime?: Maybe<ReadingTime>;
  /** Video that is associated with a post */
  video?: Maybe<Video>;
};

/** Pagination Connection interface */
export type Connection = {
  /** edges */
  edges: Array<Maybe<Edge>>;
  /** Page info */
  pageInfo?: Maybe<PageInfo>;
  /** Total edge count */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/**
 * Content Settings that are available to a member of an Account
 *
 * This Type is now deprecated alongside getContentSettingsForAccountAsMember, please use the query getMyContentSettings instead
 */
export type ContentSettingsForAccountAsMemberResponse = {
  __typename?: 'ContentSettingsForAccountAsMemberResponse';
  /**
   * Language Locales that have been configured and are available for use
   * @deprecated ContentSettingsForAccountAsMemberResponse for query getContentSettingsForAccountAsMember is deprecated, Please use the query getMyContentSettings instead. Deprecation date 2023-09-01T00:00:00Z
   */
  availableContentLocales: Array<Scalars['Locale']['output']>;
  /**
   * The default language which should be applied for content.
   * @deprecated ContentSettingsForAccountAsMemberResponse for query getContentSettingsForAccountAsMember is deprecated, Please use the query getMyContentSettings instead. Deprecation date 2023-09-01T00:00:00Z
   */
  defaultContentLocale: Scalars['Locale']['output'];
};

/** Content Settings that are available */
export type ContentSettingsResponse = {
  __typename?: 'ContentSettingsResponse';
  /** Language Locales that have been configured and are available */
  availableContentLocales: Array<Scalars['Locale']['output']>;
  /** The default language which should be applied for content. */
  defaultContentLocale: Scalars['Locale']['output'];
  /** Flag indicating if the Organisation has auto-translate enabled for Email */
  emailAutoTranslateEnabled?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Flag indicating if the account has enabled AI content assist
   * @deprecated Extracted to EnterpriseSubAccountSettings. Deprecation date 2024-04-26T00:00:00Z
   */
  enableAiContentAssist?: Maybe<Scalars['Boolean']['output']>;
  /** Flag indicating if the Organisation has auto-translate enabled for Feeds */
  feedsAutoTranslateEnabled?: Maybe<Scalars['Boolean']['output']>;
};

/** Demographic information from the app */
export type DemographicInput = {
  /** Application version */
  appVersion?: InputMaybe<Scalars['String']['input']>;
  /** Application locale */
  locale?: InputMaybe<Scalars['String']['input']>;
};

/** Input required to deregister from teams push notifications */
export type DeregisterFromTeamsPushNotificationsInput = {
  /** MS Teams member AAD Object ID */
  memberAadObjectId: Scalars['String']['input'];
};

/** Response from deregistering from teams push notifications */
export type DeregisterFromTeamsPushNotificationsResponse = {
  __typename?: 'DeregisterFromTeamsPushNotificationsResponse';
  /** Status of the request */
  status: TeamsRegistrationResponseStatus;
};

/** Pagination Edge interface with Node and cursor */
export type Edge = {
  /** Cursor for node */
  cursor?: Maybe<Scalars['String']['output']>;
  /** Node representing object */
  node?: Maybe<Node>;
};

/** An Employee Feed Group */
export type EmployeeFeedGroup = Node & {
  __typename?: 'EmployeeFeedGroup';
  /** The feed group */
  feedGroup?: Maybe<FeedGroup>;
  /** The employee feed group id */
  id: Scalars['ID']['output'];
  /**
   * Feed subscription status
   * complexity: 5
   */
  status?: Maybe<FeedGroupSubscriptionStatus>;
};

/** A Connection object for an EmployeeFeedGroup */
export type EmployeeFeedGroupConnection = Connection & {
  __typename?: 'EmployeeFeedGroupConnection';
  /** Feed group edges */
  edges: Array<Maybe<EmployeeFeedGroupEdge>>;
  /** Page info */
  pageInfo?: Maybe<PageInfo>;
  /** Total number of feed groups */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** Sort for EmployeeFeedGroupConnection */
export type EmployeeFeedGroupConnectionSort = {
  /** Which field(s) to sort on */
  field: EmployeeFeedGroupConnectionSortField;
  /** The order of the sorting, default is ascending (ASCENDING) */
  order?: InputMaybe<SortOrder>;
};

/** Sortable field(s) for EmployeeFeedGroupConnection */
export enum EmployeeFeedGroupConnectionSortField {
  /** Sort by the name of the FeedGroup */
  FeedGroupName = 'FEED_GROUP_NAME',
}

/** An EmployeeFeedGroup edge */
export type EmployeeFeedGroupEdge = Edge & {
  __typename?: 'EmployeeFeedGroupEdge';
  /** The cursor representing this group */
  cursor?: Maybe<Scalars['String']['output']>;
  /** EmployeeFeedGroup node */
  node?: Maybe<EmployeeFeedGroup>;
};

/** Endpoint definition input for push registration */
export type EndpointDefinitionInput = {
  /** Address token */
  address?: InputMaybe<Scalars['String']['input']>;
  /** Application ID */
  applicationId?: InputMaybe<Scalars['String']['input']>;
  /** Platform specific notification service */
  channelType?: InputMaybe<Scalars['String']['input']>;
  /** Demographic information from the app */
  demographic?: InputMaybe<DemographicInput>;
  /** Effective date */
  effectiveDate?: InputMaybe<Scalars['String']['input']>;
  /** Endpoint ID concatenating employee ID, username and Device ID */
  endpointId?: InputMaybe<Scalars['String']['input']>;
  /** Endpoint status */
  endpointStatus?: InputMaybe<Scalars['String']['input']>;
  /** Feed type definition. i.e. "user" or "subscription", etc */
  feedType?: InputMaybe<Scalars['String']['input']>;
  /** Opt out preferences for push notifications */
  optOut?: InputMaybe<OptOutOptions>;
  /** JSON object with custom User attributes */
  userAttributes?: InputMaybe<Scalars['String']['input']>;
  /** User ID, concatenation of employee ID and username */
  userId?: InputMaybe<Scalars['String']['input']>;
};

/** EULA Agreement details */
export type EulaAgreementPayload = {
  __typename?: 'EulaAgreementPayload';
  /** EULA Agreement already accepted for the requester */
  alreadyAccepted?: Maybe<Scalars['Boolean']['output']>;
  /** Display EULA Document URL in html */
  displayHtmlUrl?: Maybe<Scalars['String']['output']>;
  /** Downloadable EULA Document URL in pdf */
  downloadPdfUrl?: Maybe<Scalars['String']['output']>;
};

/** A Feed Group */
export type FeedGroup = Node & {
  __typename?: 'FeedGroup';
  /** Marks a feed group as archived or not. True if archived, false if not */
  archived: Scalars['Boolean']['output'];
  /** Marks a feed group as mandatory or optional and further indicates if what the default state will be for new users */
  feedGroupAudienceType?: Maybe<FeedGroupAudienceType>;
  /** The feed group id */
  id: Scalars['ID']['output'];
  /**
   * Marks a feed group as mandatory or optional. True if mandatory, false if optional
   * @deprecated mandatory will be included in new attribute feedGroupAudienceType. Deprecation date 2023-10-30T00:00:00Z
   */
  mandatory: Scalars['Boolean']['output'];
  /** Name of the feed group */
  name: Scalars['String']['output'];
  /** The posts in the feed group */
  posts?: Maybe<FeedResponseConnection>;
};

/** A Feed Group */
export type FeedGroupPostsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  enterpriseId?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  language?: InputMaybe<Scalars['Locale']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  postType?: InputMaybe<PostType>;
  sortField?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<SortOrder>;
};

/** Indicates if the user can unsubscribe and whether or not users will be subscribed by default */
export enum FeedGroupAudienceType {
  /** The feed group cannot be unsubscribed from */
  Mandatory = 'MANDATORY',
  /** The feed group can be unsubscribed, but is subscribed to initially */
  OptionalSubscribedByDefault = 'OPTIONAL_SUBSCRIBED_BY_DEFAULT',
  /** The feed group can be unsubscribed, and is unsubscribed to initially */
  OptionalUnsubscribedByDefault = 'OPTIONAL_UNSUBSCRIBED_BY_DEFAULT',
}

/** A Connection object for a FeedGroup */
export type FeedGroupConnection = Connection & {
  __typename?: 'FeedGroupConnection';
  /** Feed group edges */
  edges: Array<Maybe<FeedGroupEdge>>;
  /** Page info */
  pageInfo?: Maybe<PageInfo>;
  /** Total number of feed groups */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A FeedGroup edge */
export type FeedGroupEdge = Edge & {
  __typename?: 'FeedGroupEdge';
  /** The cursor representing this group */
  cursor?: Maybe<Scalars['String']['output']>;
  /** FeedGroup */
  node?: Maybe<FeedGroup>;
};

/** The feed group subscription status */
export enum FeedGroupSubscriptionStatus {
  /** If the feed group is being followed */
  Following = 'FOLLOWING',
  /** If the feed group is not being followed */
  NotFollowing = 'NOT_FOLLOWING',
  /** If it's a mandatory subscription */
  Required = 'REQUIRED',
}

/** A list of posts from a feed. Use the lastToken to get the next page of posts */
export type FeedResponse = {
  __typename?: 'FeedResponse';
  /** Count of enriched feed posts */
  count: Scalars['Int']['output'];
  /** A list of enriched feed posts. */
  feed: Array<Post>;
  /** Denotes the starting position of the next page */
  lastToken?: Maybe<Scalars['String']['output']>;
};

/** Feeds Response Connection holds posts under the list of FeedResponseEdge along with the cursor based paging information */
export type FeedResponseConnection = Connection & {
  __typename?: 'FeedResponseConnection';
  /** Posts */
  edges: Array<Maybe<FeedResponseEdge>>;
  /** Paging information */
  pageInfo?: Maybe<PageInfo>;
  /** Total count of posts */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** Feed Response Edge holds a post node along with the cursor based paging information */
export type FeedResponseEdge = Edge & {
  __typename?: 'FeedResponseEdge';
  /** Cursor for node */
  cursor?: Maybe<Scalars['String']['output']>;
  /** Node representing Post object */
  node?: Maybe<Post>;
};

/** Response from registering for push notifications */
export type IChannelsRegistrationResponse = {
  __typename?: 'IChannelsRegistrationResponse';
  /** Error message if any occurred */
  body?: Maybe<Scalars['String']['output']>;
  /** The Endpoint Id if successful response */
  endpointId?: Maybe<Scalars['String']['output']>;
  /** Endpoint ID concatenating employee ID, username and Device ID */
  statusCode: Scalars['Int']['output'];
};

/** Image details */
export type Image = {
  __typename?: 'Image';
  /** Denotes whether the image is public or not */
  public: Scalars['Boolean']['output'];
  /** Url location for image */
  url: Scalars['String']['output'];
};

/** Link details */
export type Link = {
  __typename?: 'Link';
  /** Domain of the link */
  domain: Scalars['String']['output'];
  /** Associated logo image for displaying the link */
  logo: Scalars['String']['output'];
  /** URL of the link */
  url: Scalars['String']['output'];
};

/** Root Mutation type */
export type Mutation = {
  __typename?: 'Mutation';
  /**
   * Accept the latest EULA agreement on behalf of the current user
   * ---
   * title: Accept EULA Agreement
   * context: Internal
   * tags: [Platform, Eula]
   * ---
   */
  acceptEulaAgreement?: Maybe<AcceptEulaAgreementPayload>;
  /**
   * Create a comment on a post
   * ---
   * title: Create Post Comment
   * context: Content
   * tags: [Content]
   * ---
   */
  createPostComment?: Maybe<Comment>;
  /**
   * Create a reaction on a post
   * ---
   * title: Create Reaction
   * context: Content
   * tags: [Content]
   * ---
   */
  createReaction?: Maybe<Reaction>;
  /**
   * Deregister from Teams push notifications to no longer receive notifications to Teams
   * ---
   * title: Deregister from Teams Push Notifications
   * context: Distribution
   * tags: [Distribution]
   * ---
   */
  deregisterFromTeamsPushNotifications: DeregisterFromTeamsPushNotificationsResponse;
  /**
   * Follow a feed group for the employee
   * ---
   * title: Follow Employee Feed Group
   * context: Content
   * tags: [Content]
   * ---
   */
  followEmployeeFeedGroup?: Maybe<EmployeeFeedGroup>;
  /**
   * Register endpoint for push notifications and returns the registered endpointId
   * ---
   * title: Register Endpoint for Push Notifications
   * context: Distribution
   * tags: [Distribution]
   * ---
   */
  registerForPushNotifications?: Maybe<IChannelsRegistrationResponse>;
  /**
   * Register endpoint for Teams push notifications and returns status code and body if error
   * ---
   * title: Register Endpoint for Teams Push Notifications
   * context: Distribution
   * tags: [Distribution]
   * ---
   */
  registerForTeamsPushNotifications?: Maybe<ChannelsTeamsPushRegistrationResponse>;
  /**
   * Resets the unseen post count for a user based on the user id and the enterprise id from the context.
   * ---
   * title: Reset Unseen Post Count
   * context: Content
   * tags: [Content]
   * ---
   */
  resetUnseenPostCount?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Unfollow a feed group for the employee
   * ---
   * title: Unfollow Employee Feed Group
   * context: Content
   * tags: [Content]
   * ---
   */
  unfollowEmployeeFeedGroup?: Maybe<EmployeeFeedGroup>;
  /**
   * Update the status for an existing comment on a post
   * ---
   * title: Update Post Comment
   * context: Content
   * tags: [Content]
   * ---
   */
  updatePostComment?: Maybe<Comment>;
  /**
   * Update a post reaction
   * ---
   * title: Update Reaction
   * context: Content
   * tags: [Content]
   * ---
   */
  updateReaction?: Maybe<Reaction>;
};

/** Root Mutation type */
export type MutationCreatePostCommentArgs = {
  comment: Scalars['String']['input'];
  enterpriseId?: InputMaybe<Scalars['ID']['input']>;
  postId: Scalars['String']['input'];
};

/** Root Mutation type */
export type MutationCreateReactionArgs = {
  enterpriseId?: InputMaybe<Scalars['ID']['input']>;
  postId: Scalars['String']['input'];
  reactionType: ReactionType;
};

/** Root Mutation type */
export type MutationDeregisterFromTeamsPushNotificationsArgs = {
  input: DeregisterFromTeamsPushNotificationsInput;
};

/** Root Mutation type */
export type MutationFollowEmployeeFeedGroupArgs = {
  employeeFeedGroupId: Scalars['ID']['input'];
};

/** Root Mutation type */
export type MutationRegisterForPushNotificationsArgs = {
  input: PushRegistrationInput;
};

/** Root Mutation type */
export type MutationRegisterForTeamsPushNotificationsArgs = {
  input: TeamsPushRegistrationInput;
};

/** Root Mutation type */
export type MutationUnfollowEmployeeFeedGroupArgs = {
  employeeFeedGroupId: Scalars['ID']['input'];
};

/** Root Mutation type */
export type MutationUpdatePostCommentArgs = {
  commentId: Scalars['String']['input'];
  enterpriseId?: InputMaybe<Scalars['ID']['input']>;
  postId: Scalars['String']['input'];
  status: Status;
};

/** Root Mutation type */
export type MutationUpdateReactionArgs = {
  enterpriseId?: InputMaybe<Scalars['ID']['input']>;
  postId: Scalars['String']['input'];
  reactionId: Scalars['String']['input'];
  status: Status;
};

/** Required in order to add pagination to a type */
export type Node = {
  /** Node Identifier */
  id: Scalars['ID']['output'];
};

/** Push registration OptOut Options */
export enum OptOutOptions {
  /** Opt out from all */
  All = 'ALL',
  /** Opt out from none */
  None = 'NONE',
}

/** Pagination page info */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** End of page cursor */
  endCursor: Scalars['String']['output'];
  /** Has next page */
  hasNextPage: Scalars['Boolean']['output'];
  /** Has previous page */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** Start of page cursor */
  startCursor: Scalars['String']['output'];
};

/** Options for pagination */
export type PaginationOptions = {
  /** Used for pagination to get the next page of data after the specified cursor. The `last` & `before` fields MUST be `NULL` when using this field. */
  after?: InputMaybe<Scalars['String']['input']>;
  /** Used for pagination to get the previous page of data before the specified cursor. The `first` & `after` fields MUST be `NULL` when using this field. */
  before?: InputMaybe<Scalars['String']['input']>;
  /** Used for pagination to specify the number of items returned. The `last` & `before` fields MUST be `NULL` when using this field. */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** Used for pagination to specify the number of items returned. The `first` & `after` fields MUST be `NULL` when using this field. */
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** Represents a content post. It holds essential information about the post, including the author, the body of the post and related comments and reactions. */
export type Post = Node & {
  __typename?: 'Post';
  /** Account id associated with the post */
  accountId: Scalars['Int']['output'];
  /** Denotes the type of article. Typically used for feed display purposes */
  articleCategory: ArticleCategory;
  /**
   * Intended audience of the post
   * @deprecated audience is unused. Deprecation date 2023-09-07T00:00:00Z
   */
  audience?: Maybe<Scalars['String']['output']>;
  /** Author of the post */
  author?: Maybe<Scalars['String']['output']>;
  /** Content of the post */
  body: Array<Scalars['String']['output']>;
  /** Denotes if the post body was auto translated by the system */
  bodyAutoTranslated: Scalars['Boolean']['output'];
  /** Campaign code related to the post */
  campaignCode?: Maybe<Scalars['String']['output']>;
  /**
   * Comments related to the post
   * @deprecated feedPostComments should be used instead. Deprecation date 2022-11-03T00:00:00Z
   */
  comments?: Maybe<Comments>;
  /** Denotes if comments are enabled for the post */
  commentsEnabled: Scalars['Boolean']['output'];
  /** Components related to the post. It holds information on video links, attachments, images etc. */
  components: Components;
  /** Denotes the contentType of post */
  contentType?: Maybe<Scalars['String']['output']>;
  /** EmployeeFeedGroup associated with the post */
  employeeFeedGroup?: Maybe<EmployeeFeedGroup>;
  /** EnterpriseId associated with the post */
  enterpriseId: Scalars['Int']['output'];
  /** Denotes whether the post is a featured post or not */
  featured: Scalars['Boolean']['output'];
  /** Comments related to the post. The comments are returned as a paginated list */
  feedPostComments?: Maybe<PostCommentsConnection>;
  /** Unique identifier of the post */
  id: Scalars['ID']['output'];
  /** The language of the post body content in BCP-47 standard format */
  language: Scalars['Locale']['output'];
  /** Denotes if the post has push notifications enabled */
  notifications: Scalars['Boolean']['output'];
  /** Denotes if the link for the post can be publicly shared. For example a mobile application can turn on or off sharing options based on this setting. */
  publiclySharable: Scalars['Boolean']['output'];
  /** Reactions related to the post. It holds a list of reactions alongside specific summary data such as the like count */
  reactions?: Maybe<Reactions>;
  /** Denotes if reactions are enabled for the post */
  reactionsEnabled: Scalars['Boolean']['output'];
  /** Denotes if the post body content is in right-to-left orientation */
  rtl?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Denotes if the user making the request has seen the post
   * @deprecated Will be removed after GetUnreadPosts. Deprecation date 2022-06-29T00:00:00Z
   */
  seen?: Maybe<Scalars['Boolean']['output']>;
  /** Current publication status of the post */
  status: Status;
  /** Epoch time of when the post was initially created */
  timeOfCreation: Scalars['String']['output'];
  /** Epoch time of when the post was published */
  timeOfPublish: Scalars['String']['output'];
  /** Title of the post */
  title: Scalars['String']['output'];
};

/** Represents a content post. It holds essential information about the post, including the author, the body of the post and related comments and reactions. */
export type PostFeedPostCommentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** Post Comment Edge holds a comment node along with the cursor based paging information */
export type PostCommentEdge = Edge & {
  __typename?: 'PostCommentEdge';
  /** Post comment node cursor */
  cursor?: Maybe<Scalars['String']['output']>;
  /** Post comment node */
  node?: Maybe<Comment>;
};

/** Post Comments Connection holds the post comment under the list of PostCommentEdge along with the cursor based paging information */
export type PostCommentsConnection = Connection & {
  __typename?: 'PostCommentsConnection';
  /** Post comments */
  edges: Array<Maybe<PostCommentEdge>>;
  /** Paging information */
  pageInfo?: Maybe<PageInfo>;
  /** Total count of comments */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** List of available post types to organise content by */
export enum PostType {
  /** All post content */
  All = 'ALL',
  /** Featured post content */
  Featured = 'FEATURED',
  /** Non-featured post content */
  Nonfeatured = 'NONFEATURED',
}

/** Push registration input properties */
export type PushRegistrationInput = {
  /** Target channel */
  channel?: InputMaybe<Scalars['String']['input']>;
  /** The unique device identifier. This might become required in the future. */
  deviceId?: InputMaybe<Scalars['String']['input']>;
  /** Endpoint definition */
  endpointDefinition?: InputMaybe<EndpointDefinitionInput>;
  /** Endpoint ID concatenating employee ID, username and Device ID */
  endpointId: Scalars['String']['input'];
  /**
   * Enterprise Account ID
   * @deprecated This field will no longer be supported. Deprecation date 2022-04-01T00:00:00Z
   */
  enterpriseId?: InputMaybe<Scalars['String']['input']>;
  /** Endpoint definition */
  payload?: InputMaybe<EndpointDefinitionInput>;
  /** Alternative channel type */
  type?: InputMaybe<Scalars['String']['input']>;
  /**
   * Unique Person ID
   * @deprecated This field will no longer be supported. Deprecation date 2022-04-01T00:00:00Z
   */
  upid?: InputMaybe<Scalars['String']['input']>;
};

/** Root Query type */
export type Query = {
  __typename?: 'Query';
  /**
   * Get Content Settings For Member
   * ---
   * title: Get Account Content Settings As Member
   * context: Internal
   * tags: [Config, Content]
   * ---
   * @deprecated getContentSettingsForAccountAsMember is deprecated, Please use getMyContentSettings instead. Deprecation date 2023-09-01T00:00:00Z
   */
  getContentSettingsForAccountAsMember?: Maybe<ContentSettingsForAccountAsMemberResponse>;
  /**
   * Get a single feed group by groupId for an employee
   * ---
   * title: Get Employee Feed Group
   * context: Content
   * tags: [Content]
   * ---
   */
  getEmployeeFeedGroupByEmployeeId?: Maybe<EmployeeFeedGroup>;
  /**
   * Get all feed groups for an employee
   *
   * For operational reasons a max page size limit of 50 groups is set for pagination.
   * If first or last are not set, then the following rules apply:
   * - If before is set, then the last 50 groups are returned
   * - In all other cases the first 50 groups are returned
   *
   * Note that archived groups are not returned as part of this operation
   * ---
   * title: Get Employee Feed Groups
   * context: Content
   * tags: [Content]
   * ---
   */
  getEmployeeFeedGroupsByEmployeeId?: Maybe<EmployeeFeedGroupConnection>;
  /**
   * Get the latest EULA Agreement
   * ---
   * title: Get EULA Agreement
   * context: Internal
   * tags: [Platform, Eula]
   * ---
   */
  getEulaAgreement?: Maybe<EulaAgreementPayload>;
  /**
   * Get a list of posts for a specific group
   * ---
   * title: Get Group Posts
   * context: Content
   * tags: [Content]
   * ---
   */
  getGroupPosts: FeedResponseConnection;
  /**
   * Get the content settings for the current user
   * ---
   * title: Get My Content Settings
   * context: Internal
   * tags: [Config, Content]
   * ---
   */
  getMyContentSettings?: Maybe<ContentSettingsResponse>;
  /**
   * Get a single post
   * ---
   * title: Get Post
   * context: Content
   * tags: [Content]
   * ---
   */
  getPost: Post;
  /**
   * Get a list of posts
   * ---
   * title: Get Posts
   * context: Content
   * tags: [Content]
   * ---
   */
  getPosts: FeedResponseConnection;
  /**
   * Get Reaction of the current user on a post
   * ---
   * title: Get Reaction
   * context: Content
   * tags: [Content]
   * ---
   */
  getReaction?: Maybe<Reaction>;
  /**
   * Get a list of unread posts - this query is no longer supported. Will be removed after deprecation date.
   * ---
   * title: Get Unread Posts
   * context: Content
   * tags: [Content]
   * ---
   * @deprecated GetUnreadPosts is no longer supported. Deprecation date 2022-06-29T00:00:00Z
   */
  getUnreadPosts: UnreadResponse;
  /**
   * Gets the unseen post count for a user based on the user id and the enterprise id from the context.
   * ---
   * title: Get Unseen Post Count
   * context: Content
   * tags: [Content]
   * ---
   */
  getUnseenPostCount?: Maybe<Scalars['Int']['output']>;
};

/** Root Query type */
export type QueryGetContentSettingsForAccountAsMemberArgs = {
  accountId: Scalars['ID']['input'];
};

/** Root Query type */
export type QueryGetEmployeeFeedGroupByEmployeeIdArgs = {
  groupId: Scalars['ID']['input'];
};

/** Root Query type */
export type QueryGetEmployeeFeedGroupsByEmployeeIdArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<EmployeeFeedGroupConnectionSort>;
};

/** Root Query type */
export type QueryGetGroupPostsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  enterpriseId?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  groupId: Scalars['ID']['input'];
  language?: InputMaybe<Scalars['Locale']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  postType?: InputMaybe<PostType>;
  sortField?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<SortOrder>;
};

/** Root Query type */
export type QueryGetPostArgs = {
  enterpriseId?: InputMaybe<Scalars['ID']['input']>;
  language?: InputMaybe<Scalars['Locale']['input']>;
  postId: Scalars['ID']['input'];
};

/** Root Query type */
export type QueryGetPostsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  enterpriseId?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  language?: InputMaybe<Scalars['Locale']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  postType?: InputMaybe<PostType>;
  sortField?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<SortOrder>;
};

/** Root Query type */
export type QueryGetReactionArgs = {
  enterpriseId?: InputMaybe<Scalars['ID']['input']>;
  postId: Scalars['String']['input'];
};

/** Root Query type */
export type QueryGetUnreadPostsArgs = {
  enterpriseId?: InputMaybe<Scalars['ID']['input']>;
};

/** Reaction on a post */
export type Reaction = {
  __typename?: 'Reaction';
  /** Name of user who reacted */
  author: Scalars['String']['output'];
  /**
   * Cognito identifier of user who reacted
   * @deprecated Legacy identification token - deprecated in favour of poppuloId. Deprecation date 2022-11-03T00:00:00Z
   */
  cognitoSubId?: Maybe<Scalars['String']['output']>;
  /** The type of reaction */
  content: ReactionType;
  /** Poppulo identifier of user who reacted */
  poppuloId?: Maybe<Scalars['String']['output']>;
  /** Post id associated with this reaction */
  postId: Scalars['String']['output'];
  /** Unique identifier of the reaction */
  reactionId: Scalars['String']['output'];
  /** Publication status of the reaction */
  status?: Maybe<Status>;
  /** Epoch time for when the reaction was created */
  timeOfPublish: Scalars['String']['output'];
};

/** List of available reaction types */
export enum ReactionType {
  /** Like reaction */
  Like = 'LIKE',
}

/** Reactions Type */
export type Reactions = {
  __typename?: 'Reactions';
  /** Count of reactions related to feed query */
  likeCount: Scalars['Int']['output'];
  /** Denotes whether feed query has previously been reacted to by the user */
  likedByUser: Scalars['Boolean']['output'];
  /** List of reactions related to feed query */
  reactions: Array<Reaction>;
};

/** Reading time details */
export type ReadingTime = {
  __typename?: 'ReadingTime';
  /** Estimated reading time for the content */
  time: Scalars['Int']['output'];
};

/** Sort Order */
export enum SortOrder {
  /** Sort in ascending order */
  Ascending = 'ASCENDING',
  /** Sort in descending order */
  Descending = 'DESCENDING',
}

/** List of available publish statuses for an item */
export enum Status {
  /** Deleted item */
  Deleted = 'DELETED',
  /** Pending Published item */
  PendingPublished = 'PENDING_PUBLISHED',
  /** Published item */
  Published = 'PUBLISHED',
}

/** Conversation Reference for Teams */
export type TeamsConversationReference = {
  /** Teams ConversationId */
  conversationId?: InputMaybe<Scalars['String']['input']>;
  /** Teams TenantId */
  tenantId?: InputMaybe<Scalars['String']['input']>;
};

/** Endpoint definition input for push registration */
export type TeamsEndpointDefinitionInput = {
  /** channel Id */
  channelId?: InputMaybe<Scalars['String']['input']>;
  /** Conversation details */
  conversation?: InputMaybe<TeamsConversationReference>;
  /** Registered user details */
  membersAdded?: InputMaybe<TeamsMembersAdded>;
  /** Service URL */
  serviceUrl?: InputMaybe<Scalars['String']['input']>;
};

/** Members Added for Teams */
export type TeamsMembersAdded = {
  /** AAD ID of user */
  aadObjectId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the user from bots perspective */
  id?: InputMaybe<Scalars['String']['input']>;
};

/** Team Push Notification registration input */
export type TeamsPushRegistrationInput = {
  /** Target channel */
  channel: Scalars['String']['input'];
  /** Endpoint definition */
  endpointDefinition: TeamsEndpointDefinitionInput;
};

/** Status enum for teams registration response */
export enum TeamsRegistrationResponseStatus {
  /** Fail Status */
  Failure = 'FAILURE',
  /** Success status */
  Success = 'SUCCESS',
}

/** Unread post id */
export type Unread = {
  __typename?: 'Unread';
  /** Post id of unread post - this response type is no longer supported. Will be removed after GetUnreadPosts deprecation. */
  id: Scalars['String']['output'];
};

/** The response for a list of unread posts - this response type is no longer supported. Will be removed after GetUnreadPosts deprecation. */
export type UnreadResponse = {
  __typename?: 'UnreadResponse';
  /** The number of unread posts */
  count: Scalars['Int']['output'];
  /** A list of unread posts ids */
  feedIds: Array<Unread>;
};

/** Video details */
export type Video = {
  __typename?: 'Video';
  /**
   * URL used for authorization to download video
   * @deprecated authUrl is no longer required to view video content. Deprecation date 2023-09-20T00:00:00Z
   */
  authUrl?: Maybe<Scalars['String']['output']>;
  /** Name of video file */
  fileName: Scalars['String']['output'];
  /** Location of thumbnails for video */
  thumbnails?: Maybe<Array<Scalars['String']['output']>>;
  /** FileType of video */
  type: Scalars['String']['output'];
  /** URL location of video */
  url: Scalars['String']['output'];
};

export type ResetUnreadCountMutationVariables = Exact<{ [key: string]: never }>;

export type ResetUnreadCountMutation = {
  __typename?: 'Mutation';
  resetUnseenPostCount?: boolean | null;
};

export const ResetUnreadCountDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ResetUnreadCount' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'resetUnseenPostCount' } }],
      },
    },
  ],
} as unknown as DocumentNode<ResetUnreadCountMutation, ResetUnreadCountMutationVariables>;
